import http from "@/http-common";

class GroupAdminService {
  getGroupList(data: any): Promise<any> {
    return http.api.post("/getGroupList/",data);
  }
  getGroupAdminList(data: any): Promise<any> {
    return http.api.post("/getGroupAdminList/",data);
  }
  getGroupIDInfo(data: any): Promise<any> {
    return http.api.post("/getGroupIDInfo/",data);
  }
  insertGroup(data: any): Promise<any> {
    return http.api.post("/insertGroup/",data);
  }
  insertMenuApproval(data: any): Promise<any> {
    return http.api.post("/insertMenuApproval/",data);
  }
  deleteMenuApproval(data: any): Promise<any> {
    return http.api.post("/deleteMenuApproval/",data);
  }
  updateGroup(data: any): Promise<any> {
    return http.api.post("/updateGroup/",data);
  }
  
}
export default new GroupAdminService();
